import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function WalkInBooking() {
  const user = JSON.parse(localStorage.getItem('sdx_user') || '{}');
  const [hubs, setHubs] = useState([]);
  const [form, setForm] = useState({
    sender_name: '', sender_phone: '', pickup_address: 'At Hub Counter', pickup_hub_id: user.hub_id || 1,
    receiver_name: '', receiver_phone: '', delivery_address: '', destination_hub_id: '',
    description: '', declared_value: '', declared_weight_kg: '',
    delivery_option: 'hub_pickup', booking_fee: 50, delivery_fee: 20,
    booking_payment_method: 'cash', booked_via: 'walk_in',
  });
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => { api.get('/hubs').then(r => setHubs(r.data)); }, []);
  const upd = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async () => {
    setError('');
    try {
      const res = await api.post('/parcels', {
        ...form,
        pickup_hub_id: Number(form.pickup_hub_id),
        destination_hub_id: Number(form.destination_hub_id),
        booking_fee: Number(form.booking_fee),
        delivery_fee: Number(form.delivery_fee),
        declared_value: Number(form.declared_value) || 0,
        declared_weight_kg: Number(form.declared_weight_kg) || null,
      });
      setResult(res.data);
    } catch (e) { setError(e.response?.data?.error || 'Error'); }
  };

  const reset = () => { setResult(null); setError(''); setForm(f => ({ ...f, sender_name: '', sender_phone: '', receiver_name: '', receiver_phone: '', description: '', declared_value: '', declared_weight_kg: '' })); };

  if (result) {
    return (
      <div>
        <h1>Walk-in Booking</h1>
        <div className="card" style={{ textAlign: 'center', background: '#dcfce7', border: '1px solid #86efac' }}>
          <h2 style={{ color: '#166534' }}>Booked ✓ Cash Received</h2>
          <div className="label">Tracking Number</div>
          <div style={{ fontSize: 24, fontWeight: 800 }}>{result.tracking_number}</div>
          <div className="label" style={{ marginTop: 12 }}>Pickup PIN</div>
          <div style={{ fontSize: 32, fontWeight: 800, letterSpacing: 8, color: '#dc2626' }}>{result.pickup_pin}</div>
          <p style={{ marginTop: 16, fontSize: 13, color: '#374151' }}>Print label + attach to parcel. Give receipt to sender.</p>
          <button className="btn btn-primary" onClick={reset}>New Booking</button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1>Walk-in Booking</h1>
      <div className="card">
        <p style={{ color: '#6b7280', marginTop: 0 }}>Customer walks in with parcel. Auto-marked as <strong>received at hub</strong>. Cash payment goes into hub drawer immediately.</p>
        <h3 style={{ fontSize: 13, color: '#6b7280', marginTop: 20 }}>SENDER</h3>
        <input className="input" placeholder="Sender name" value={form.sender_name} onChange={e => upd('sender_name', e.target.value)} />
        <input className="input" placeholder="Sender phone" value={form.sender_phone} onChange={e => upd('sender_phone', e.target.value)} />

        <h3 style={{ fontSize: 13, color: '#6b7280', marginTop: 20 }}>RECEIVER</h3>
        <input className="input" placeholder="Receiver name" value={form.receiver_name} onChange={e => upd('receiver_name', e.target.value)} />
        <input className="input" placeholder="Receiver phone" value={form.receiver_phone} onChange={e => upd('receiver_phone', e.target.value)} />
        <label className="label">Destination Hub</label>
        <select className="input" value={form.destination_hub_id} onChange={e => upd('destination_hub_id', e.target.value)}>
          <option value="">— select —</option>
          {hubs.filter(h => h.id !== Number(form.pickup_hub_id)).map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
        </select>
        <label className="label">Delivery Option</label>
        <select className="input" value={form.delivery_option} onChange={e => upd('delivery_option', e.target.value)}>
          <option value="hub_pickup">Pickup at Hub (free)</option>
          <option value="home_delivery">Home Delivery (K{form.delivery_fee})</option>
        </select>
        {form.delivery_option === 'home_delivery' && (
          <input className="input" placeholder="Delivery address" value={form.delivery_address} onChange={e => upd('delivery_address', e.target.value)} />
        )}

        <h3 style={{ fontSize: 13, color: '#6b7280', marginTop: 20 }}>PARCEL</h3>
        <input className="input" placeholder="Description" value={form.description} onChange={e => upd('description', e.target.value)} />
        <div style={{ display: 'flex', gap: 12 }}>
          <input className="input" style={{ flex: 1 }} type="number" step="0.01" placeholder="Weight (kg)" value={form.declared_weight_kg} onChange={e => upd('declared_weight_kg', e.target.value)} />
          <input className="input" style={{ flex: 1 }} type="number" placeholder="Declared value (K)" value={form.declared_value} onChange={e => upd('declared_value', e.target.value)} />
        </div>

        <h3 style={{ fontSize: 13, color: '#6b7280', marginTop: 20 }}>PAYMENT</h3>
        <div style={{ display: 'flex', gap: 12 }}>
          <input className="input" style={{ flex: 1 }} type="number" placeholder="Booking fee (K)" value={form.booking_fee} onChange={e => upd('booking_fee', e.target.value)} />
          <select className="input" style={{ flex: 1 }} value={form.booking_payment_method} onChange={e => upd('booking_payment_method', e.target.value)}>
            <option value="cash">Cash</option>
            <option value="momo">MoMo</option>
            <option value="airtel">Airtel</option>
          </select>
        </div>

        <button className="btn btn-primary" style={{ width: '100%', padding: 14, marginTop: 20 }} onClick={submit}>Confirm & Print</button>
        {error && <p style={{ color: '#dc2626', marginTop: 12 }}>{error}</p>}
      </div>
    </div>
  );
}
